import { lazy } from "react";
const Home = lazy(() => import("@pages/home/Home"));
const NotificationCenter = lazy(
  () => import("@pages/home/notificationCenter/page"),
);

const homeRoute = [
  {
    path: "/",
    name: "首页",
    component: Home,
    children: [
      {
        path: "/notification/",
        name: "工作台",
        crumbTitle: "工作台",
        children: [
          {
            path: "/notification/task",
            name: "任务中心",
            crumbTitle: "任务中心",
            component: NotificationCenter,
          },
          {
            path: "/notification/message",
            name: "消息提醒",
            crumbTitle: "消息提醒",
            component: NotificationCenter,
          },
        ],
      },
    ],
  },
];
export default homeRoute;
